import { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, createRoute, createRouter, lazyRouteComponent, Outlet, redirect } from "@tanstack/react-router";
import { EmConstrucao } from "./componentes/EmConstrucao";
import { Moldura } from "./componentes/Moldura";
import { tokenAtual } from "./sessao/supabase";
import { Entrar } from "./telas/Entrar";
import { Alteracoes } from "./telas/Alteracoes";
import { Lancamentos } from "./telas/Lancamentos";
import { ProcessoPagina } from "./telas/ProcessoPagina";
import { Processos } from "./telas/Processos";
import { Tarefas } from "./telas/Tarefas";

export const clienteConsultas = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true } },
});

const raiz = createRootRouteWithContext<{ consultas: QueryClient }>()({ component: Outlet });

const entrar = createRoute({ getParentRoute: () => raiz, path: "/entrar", component: Entrar });

// Toda tela da equipe passa por aqui: sem sessão, vai para o login.
const logado = createRoute({
  getParentRoute: () => raiz,
  id: "logado",
  component: Moldura,
  beforeLoad: async () => {
    if (!(await tokenAtual())) throw redirect({ to: "/entrar" });
  },
});

const tela = (path: string, titulo: string, ticket: string, descricao: string) =>
  createRoute({
    getParentRoute: () => logado,
    path,
    component: () => <EmConstrucao titulo={titulo} ticket={ticket} descricao={descricao} />,
  });

// Contrato visual vivo (E3-01): componentes com dados fictícios. Só no desenvolvimento, sem login; o build de
// produção elimina o ramo inteiro (nem o arquivo entra no pacote).
const soDesenvolvimento = import.meta.env.DEV
  ? ["/referencia", "/referencia/$secao"].map((path) =>
      createRoute({ getParentRoute: () => raiz, path, component: lazyRouteComponent(() => import("./telas/Referencia"), "Referencia") }))
  : [];

const arvore = raiz.addChildren([
  entrar,
  ...soDesenvolvimento,
  logado.addChildren([
    createRoute({ getParentRoute: () => logado, path: "/", component: Tarefas }),
    createRoute({
      getParentRoute: () => logado,
      path: "/processos",
      validateSearch: (s: Record<string, unknown>): { busca?: string } => (typeof s.busca === "string" ? { busca: s.busca } : {}),
      component: Processos,
    }),
    createRoute({ getParentRoute: () => logado, path: "/processos/$numero", component: ProcessoPagina }),
    createRoute({
      getParentRoute: () => logado,
      path: "/alteracoes",
      validateSearch: (s: Record<string, unknown>): { processo?: string } => (typeof s.processo === "string" ? { processo: s.processo } : {}),
      component: Alteracoes,
    }),
    tela("/agenda", "Agenda", "E4-11", "Audiências, eventos e reuniões."),
    createRoute({ getParentRoute: () => logado, path: "/lancamentos", component: Lancamentos }),
    tela("/carga", "Carga da equipe", "E4-12", "Pontos por pessoa e dia, com remanejamento. Só para gestores."),
    tela("/painel", "Painel", "E6-02 e E6-03", "Produtividade, prazos, acordos e pendências do cliente. Só para gestores."),
    tela("/conta/tokens", "Tokens pessoais", "E1-08", "Crie um token para conectar o Claude pelo MCP. Ele segue as suas permissões."),
  ]),
]);

export const roteador = createRouter({ routeTree: arvore, context: { consultas: clienteConsultas } });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof roteador;
  }
}
